import { api } from "./api";
import { clear, h } from "./dom";
import { renderLogin } from "./views/login";
import { renderTiles } from "./views/tiles";
import { renderAdmin } from "./views/admin";
import { renderStatementPage } from "./views/statement";
import { renderEditor } from "./label/editor";
import type { User } from "./types";

const app = document.getElementById("app")!;

export let currentUser: User | null = null;

let teardown: (() => void) | null = null;

async function route(): Promise<void> {
  if (teardown) {
    teardown();
    teardown = null;
  }
  const hash = location.hash || "#/";
  clear(app);

  if (hash === "#/login") {
    renderLogin(app, (user) => {
      currentUser = user;
      location.hash = "#/";
    });
    return;
  }

  if (currentUser === null) {
    try {
      currentUser = await api<User>("/api/auth/me");
    } catch {
      return; // api() redirected to #/login
    }
  }

  const labelMatch = hash.match(/^#\/(label|view)\/(\d+)$/);
  if (labelMatch) {
    try {
      teardown = await renderEditor(app, Number(labelMatch[2]), currentUser, labelMatch[1] === "view");
    } catch (e: any) {
      clear(app);
      app.append(
        h("div", { className: "login-wrap" },
          h("div", { className: "login-card" },
            h("h1", {}, "Cannot open tile"),
            h("p", { className: "form-error" }, e?.message ?? "Unknown error"),
            h("p", { className: "muted" },
              "If the tile's images were deleted for re-ingestion, re-ingest the rasters first — your labels are untouched."),
            h("button", { className: "btn btn-primary", onClick: () => (location.hash = "#/") }, "Back to tiles"))),
      );
    }
    return;
  }
  if (hash === "#/statement") {
    try {
      await renderStatementPage(app, currentUser);
    } catch (e: any) {
      app.append(h("p", { className: "form-error pad" }, e?.message ?? "Unknown error"));
    }
    return;
  }
  if (hash === "#/admin" || hash.startsWith("#/admin/")) {
    if (!currentUser.is_admin) {
      location.hash = "#/";
      return;
    }
    renderAdmin(app, currentUser);
    return;
  }
  renderTiles(app, currentUser);
}

window.addEventListener("hashchange", () => void route());
void route();
